<div class="aprova-box-error">
  <div class="aprova-box-error__details">
    <div class="aprova-box-error__icon">
      <div #iconRef>
        <ng-content select="[icon]"> </ng-content>
      </div>

      @if (!isIconSlotUsed) {
        @if (!options?.iconPath) {
        <div
          class="aprova-box-error__icon-background"
          [style]="{ background: options?.iconBackgroundColor }"
        >
          <aprova-icon
            [name]="iconName ?? 'shield-exclamation-outline'"
            [color]="iconColor ?? '#F43F5F'"
            [size]="iconSize ?? '24px'"
          />
        </div>
        } @else {
        <img [src]="options?.iconPath" />
        }
      }
    </div>
    <div
      class="aprova-box-error__message"
      [class]="options?.messageClasses"
      [class.aprova-box-error__message--left]="
        options?.messageHorizontalAlign === 'left'
      "
      [class.aprova-box-error__message--center]="
        options?.messageHorizontalAlign === 'center'
      "
      [class.aprova-box-error__message--right]="
        options?.messageHorizontalAlign === 'right'
      "
    >
      {{ message }}
    </div>
    @if (!options?.useHtmlInMessage) {
    <div
      [class]="'aprova-box-error__description ' + (options?.descriptionClasses || '')"
      [class.aprova-box-error__description--left]="
        options?.descriptionHorizontalAlign === 'left'
      "
      [class.aprova-box-error__description--center]="
        options?.descriptionHorizontalAlign === 'center'
      "
      [class.aprova-box-error__description--right]="
        options?.descriptionHorizontalAlign === 'right'
      "
    >
      {{ description }}
    </div>
    } @else {
    <div
      class="aprova-box-error__description"
      [innerHTML]="safeHtml"
    ></div>
    }
  </div>

  <ng-content select="[action]"></ng-content>
</div>
